import { useState, useEffect, useCallback } from 'react'
import { useParams } from 'react-router'
import useRouter from 'utils/useRouter'
import { useCadaverService } from 'hooks/useCadaverService'

export const useEditarCadaver = (props) => {
  const { route } = props
  const cadaverService = useCadaverService()
  const router = useRouter()
  const params = useParams()
  const [openAlertDelete, setOpenAlertDelete] = useState(false)
  const [cadaver, setCadaver] = useState({})
  const [processando, setProcessando] = useState(false)

  useEffect(() => {
    if (route.editar && params.idCadaver) {
      cadaverService.listarCadaver(params.idCadaver, setCadaver, setProcessando)
    }
  }, [route.editar, params.idCadaver])

  const handleDelete = useCallback(async () => {
    await cadaverService.excluirCadaver(params.idCadaver, setProcessando)
    router.history.push(`/casos/caso/detalhar/${cadaver.id_caso}`)
  }, [cadaver.id_caso, params.idCadaver, router])

  return {
    cadaver,
    processando,
    setProcessando,
    openAlertDelete,
    setOpenAlertDelete,
    handleDelete,
    params,
    router,
  }
}
